<template>
    <table
        class="identify-properties-viewer"
        :style="componentStyle">

        <thead
            v-if="title"
            :key="title"
            :style="titleStyle"
            class="identify-properties-viewer-title">
            <tr>
                <th colSpan="2">{{title}}</th>
            </tr>
        </thead>

        <tbody
            class="identify-properties-viewer-body">
            <tr
                v-for="item in bodyItems"
                :key="item.key"
                :style="listStyle">
                <td>{{ item.key }}</td>
                <td>
                    <template v-if="item.actions">
                        <template v-for="action in item.actions">
                            <template v-if="action.type == 'popup'">
                                <a :key="`${action.keyBind}`"
                                    :href="action.href"
                                    @click.prevent="$emit('emitOpenPopup', $event.target.href, feature, action.params, action.tools);return false;">
                                    {{ action.text }}
                                </a>
                            </template>
                            <template v-else-if="action.type == 'link'">
                                <a :key="`${action.keyBind}`"
                                    :href="action.href"
                                    :target="action.target">
                                    {{ action.text }}
                                </a>
                            </template>
                            <template v-else-if="action.type == 'event'">
                                <a :key="`${action.keyBind}`"
                                    href="#"
                                    @click.prevent="$emit('dispatchEvent', action.params, feature);return false;">
                                    {{ action.text }}
                                </a>
                            </template>
                            <template v-else-if="action.type == 'image'">
                                <img :key="`${action.keyBind}`"
                                    :src="action.href"
                                    :alt="`image`"
                                    :class="action.params?.class ?? ''">
                            </template>
                        </template>
                    </template>
                    <template v-else>
                        <div v-html="textVal(item.val)"></div>
                    </template>
                </td>
                <!-- <td>${ containsHTML(val) ? '<span dangerouslySetInnerHTML={{__html: val}}/>' : val }</td> -->
            </tr>
        </tbody>
    </table>
</template>

<script>
    import {formatString, formatUrl, isString, isJson, slugify} from '@config/utils';
    const alwaysExcluded = ["exclude", "titleStyle", "listStyle", "componentStyle", "title", "feature"];

    export default {
        name: 'RowPropertiesViewer',
        mixins: [
        ],
        components: {

        },
        props: {
            title: {
                type: String,
                default: '',
            },
            titleStyle: {
                type: Object,
                default: ()=>{},
            },
            listStyle: {
                type: Object,
                default: ()=>{},
            },
            componentStyle: {
                type: Object,
                default: ()=>{},
            },
            exclude: {
                type: Array,
                default: ()=>[],
            },
            feature: {
                type: Object,
                default: ()=>{},
            },
            featureInfo: {
                type: Object,
                default: ()=>{},
            },
            properties: {
                type: Object,
                default: ()=>{},
            },
        },
        computed: {
            bodyItems() {
                return Object.keys(this.properties)
                    .filter(this.toExclude)
                    .map((key, index) => {
                        const val = this.renderProperty(this.properties[key]);
                        let actions = this.actionVal(index, key, val, this.properties);
                        return {
                            key,
                            val,
                            actions,
                        }
                    });
            },
        },
        methods: {
            toExclude(propName) {
                return alwaysExcluded
                    .concat(this.exclude)
                    .indexOf(propName) === -1;
            },
            renderProperty(prop) {
                if (isString(prop)) {
                    return prop;
                }
                return JSON.stringify(prop);
            },
            textVal(val){
                return val ? val.trim().replace('null', '').replace('""', '') : '';
            },
            actionVal(index, key, val, properties){
                let actions = this.featureInfo.actions || [];
                let fAction = actions.find(action => action.prop===key);
                if(fAction){
                    let action = JSON.parse(JSON.stringify(fAction));
                    let acl = action.acl_code;
                    if(!acl || acl && this.$auth.check(acl)){
                        let _type = action.action;
                        let actionParams = action.params ?? {};

                        // tools
                        let tools = [];
                        let actionTools = actionParams?.tools ?? {};
                        Object.keys(actionTools).forEach(key => {
                            let tool = actionTools[key];
                            let acl = tool.acl_code;
                            if(!acl || acl && this.$auth.check(acl)){
                                this.iterate(tool, '', properties);
                                tools[key] = tool;
                            }
                        });

                        let result = [];
                        let items = [val]
                        if(actionParams?.separator) {
                            items = val.split(actionParams?.separator).map(item => item.trim());
                        }
                        items.forEach((item, idx) => {
                            let _val = item;
                            let _params = actionParams?.params ?? actionParams;
                            _params = JSON.stringify(_params);
                            properties[key] = _val;
                            for (let v in properties) {
                                var regexp = new RegExp(':'+v+'', 'gi');
                                _params = _params.replace(regexp, properties[v]);
                            }
                            if(actionParams?.params) {
                                actionParams.params = JSON.parse(_params);
                                _params = actionParams;
                            }
                            let href = action.href ? formatUrl(action.href, properties) : null;
                            if(href) {
                                let scheme = `${window.location.protocol}//`;
                                href = href.replace('http://', scheme);
                                href = href.split(scheme).filter(x => x).slice(-1).pop();
                                href = href ? `${scheme}${href}` : null;
                            }

                            result.push({
                                text: this.textVal(_val),
                                type: _type,
                                href: href,
                                target: actionParams?.target ?? null,
                                params: isString(_params) && isJson(_params) ? JSON.parse(_params) : _params,
                                tools: tools,
                                keyBind: `action-${index}-${idx}-${slugify(_type)}-${slugify(key)}`,
                            });
                        });
                        return result;
                    }
                }
                return null;
            },
            iterate(obj, stack, properties) {
                for (var property in obj) {
                    if (obj.hasOwnProperty(property)) {
                        if (typeof obj[property] == "object") {
                            this.iterate(obj[property], stack + '.' + property, properties);
                        } else {
                            formatString(obj[property], properties);
                        }
                    }
                }
            }
            // renderVal(key, val) {
            //     val = val.trim().replace('null', '').replace('""', '');
            //     let links = this.featureInfo.links || [];
            //     let link = links.find(link => link.prop===key);
            //     if(link){
            //         let acl = link.acl_code;
            //         if(!acl || acl && this.$auth.check(acl)){
            //             let url = link.href.replace(`:${key}`, val);
            //             switch(link.target.toLowerCase()){
            //                 case 'popup':
            //                     return `<a href="${url}" >${val}</a>`;
            //                 default:
            //                     return `<a href="${url}" target="${link.target}">${val}</a>`
            //             }
            //         }
            //         return val;
            //     }
            //     return val;
            // },
        }
    }

</script>

<style scoped lang="scss">
    .identify-properties-viewer {
        width: 100%;
        min-width: 256px;
        background-color: transparent;
        color: #6e6e6e;

        &table {
            border-collapse: collapse;
            border-spacing: 0;
        }

        thead {
            font-size: 1em;
            font-family: var(--city-semibold-font-family);
            background-color: #f2f2f2;
            color: #000000;
            margin-bottom: 4px;

            th {
                padding: 0 4px 4px;
                font-weight: normal;
                word-break: break-word;
            }
        }

        tbody {
            background-color: #ffffff;
            font-size: .9rem;

            tr {
                border-bottom: solid 1px #dddddd;
            }

            td {
                padding: 3px 4px 3px;

                &:first-child {
                    font-family: var(--city-semibold-font-family);
                    vertical-align: top;
                }

                &:last-child {
                    text-align: right;
                    word-break: break-word;
                    overflow-wrap: break-word;
                }
            }
        }

        + .identify-properties-viewer {
            margin-top: 1rem;
        }
    }
</style>